import { EventCard } from './EventCard';
import { RegistrationForm } from './RegistrationForm';
import { TrustIndicators } from './TrustIndicators';
import React from 'react';
import { Container, Row, Col, Card, Button, Form, Badge } from "react-bootstrap";


import { BaseData, Any, List, ModernFloatRangeExampleClass } from './BaseData.js';
import { RenderControlData } from './RenderControlData.js';

function SignupHero({
  section,
}) {
  const heroStyle = {
    // backgroundImage: 'url("/images/hero-bg.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    margin: "30px",
    marginLeft: "0px",
    // color: '#fff'
  };
  const overlayStyle = {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    // backgroundColor: 'rgba(224, 247, 250,1)'
  };
  const contentStyle = {
    position: 'relative',
    zIndex: 1,
    paddingTop: '1rem',
    paddingBottom: '0rem'

  };

  const handleFormSubmit = async (e) => {};

  return (
    <section style={heroStyle}>
      <div style={overlayStyle} />
      <Container style={contentStyle}>
        <Row>
          <Col md={12}>
            {(!section.beTheFooter || section.beTheFooter == false) && (
              <div>
                {/* <Badge
                  bg="warning"
                  text="dark"
                  className="mb-3 text-uppercase"
                >
                  2-Days of Creative Workshops
                </Badge> */}
                <h1 className="display-2  mt-4">{section.title || 'missing title'}</h1>
                <p className="lead mt-5">
                  {section.subtitle || 'Learn how to deepen and widen your creative process'}
                </p>
              </div>
            )}
            <br/><br/>
            <Row  className="g-3 justify-content-end">
              {section.cards.map((card, idx) => {
                if (card.render_control_type === 'event_card') {
                  return (
                    <Col key={idx} md={4}>
                      <EventCard
                        {...card}
                        // card={card}
                        // title={card.title}
                        // actionLabel={card.actionLabel}
                        // date={card.date}
                        // time={card.time || ''}
                        // location={card.location}
                        // actionHref={card.actionHref}
                      />
                    </Col>
                  );
                }

                if (card.render_control_type === 'registration_form') {
                  return (
                    <Col key={idx} md={4}>
                      <RegistrationForm
                        title={card.formTitle}
                        subtitle={card.formSubtitle}
                        onSubmit={handleFormSubmit}
                      />
                    </Col>
                  );
                }

                return null;
              })}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}


class SignupHeroData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    beTheFooter: Boolean,

    // non-card content (a)
    title: String,
    subtitle: String,
    ctaLabel: String,
    ctaHref: String,

    // cards list (b) — raw, will be instanced via mkCardInstance
    cards: List(Any),
  });
}



class EventCardData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    title: String,
    description: String,
    date: String,
    location: String,
    badge: String,
    image: String,
    actionLabel: String,
    actionHref: String,
  });
}


export {SignupHero,SignupHeroData,EventCardData};
export default  SignupHero;

/**
 * LLM THIS IS EXAMPLE DATA THAT CAN POPULATE SIGNUP HERO
{
  "render_control_type": "signup_hero",
  "beTheFooter": false,
  "title": "Creativity and Automation",
  "subtitle": "With 15 years in software, and 3 of those as a published AI researcher, justin brings deep technical capabilility to both practical and creative projects.",
  "ctaLabel": "",
  "ctaHref": "",
  "cards": [
    {
      "render_control_type": "event_card",
      "title": "ai strategy report",
      "date": "Free Consult",
      "description": "desc",
      "badge": "badge",
      "image": "image",

      "location": "Have a technical question? Perhaps you just want to brainstorm?",
      "actionLabel": "Calendly →",
      "actionHref": "https://calendly.com/justingirard/ai-art-chat"
    },
    {
      "render_control_type": "event_card",
      "title": "In person workshops",
      "date": "Next Training",
      "description": "desc",
      "badge": "badge",
      "image": "image",
      "location": "Intro to AI Art for artists is a hands on crash course in AI for artists.",
      "actionLabel": "Learn →",
      "actionHref": "https://www.eventbrite.ca/e/making-ai-useful-to-creatives-and-agencies-tickets-1859345254709"
    },
    {
      "render_control_type": "registration_form",
      "formTitle": "Event Newsletter",
      "formSubtitle": "Sign up for announcements!",
      "actionUrl": "",
      "submitLabel": "Submit",
      "fields": [
        {
          "name": "name",
          "label": "Name",
          "type": "text",
          "placeholder": "Your name",
          "required": false
        },
        {
          "name": "email",
          "label": "Email",
          "type": "email",
          "placeholder": "you@example.com",
          "required": true
        }
      ]
    }
  ]
}

 * 
 */